// This file is part of the JACoW plugin.
// Copyright (C) 2021 - 2026 CERN
//
// The CERN Indico plugins are free software; you can redistribute
// them and/or modify them under the terms of the MIT License; see
// the LICENSE file for more details.

import {bindTranslateComponents} from 'indico/react/i18n';

const {Translate, PluralTranslate} = bindTranslateComponents('jacow');

export {Translate, PluralTranslate};
export {Singular, Plural} from 'react-jsx-i18n';
